// src/views/.../components/FinalPage/FinalPage.tsx
import React from 'react';
import { Icon } from '../../../../../../../components/common/IconLibrary';
import QRCode from 'react-qr-code';
import './FinalPage.scss';
import { ReservationConfirmation } from '../../types';

interface FinalPageProps {
  reservationConfirmation: ReservationConfirmation;
}

export default function FinalPage({ reservationConfirmation }: FinalPageProps) {
  const {
    reservation_id,
    client_name,
    reservation_date,
    init,
    end,
    n_people,
  } = reservationConfirmation;

  const formatSlot = (s: number) => {
    const h = Math.floor(s / 4),
      m = (s % 4) * 15;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
  };

  const url = `${window.location.origin}/Reservations/MyReservation/${reservation_id}`;

  return (

    <>

        <div className="centered-icon">
          <Icon iconName="check" iconColor="orange" size={64} />
        </div>

        <h1>¡Reserva Agendada!</h1>

        <div className="reservation-details">
          <div className="detail-row">
            <span className="label">Nombre:</span>
            <span className="value">{client_name}</span>
          </div>
          <div className="detail-row">
            <span className="label">Fecha:</span>
            <span className="value">{reservation_date}</span>
          </div>
          <div className="detail-row">
            <span className="label">Hora:</span>
            <span className="value">{formatSlot(init)}</span>
          </div>
          <div className="detail-row">
            <span className="label">Personas:</span>
            <span className="value">{n_people}</span>
          </div>
        </div>

        <div className="qr-code">
          <QRCode value={url} size={180} />
        </div>
        <p className="qr-caption">Escanea para ver o compartir</p>
</>
  );
}
